import React, { useRef } from "react";
import {
    Column,
    FilterRow,
    SearchPanel,
    Lookup,
    Pager,
    Paging,
    Export,
    Editing,
    Popup,
    Form,   
    StringLengthRule,
    EmailRule,
} from 'devextreme-react/data-grid';
import { DataGrid } from 'devextreme-react';
import { createStore } from "../../utils/proxy";
import { confirm } from 'devextreme/ui/dialog';

import BlockHeader from '../../components/shared/BlockHeader';
import Title from "../../components/shared/Title";
import { store } from "../../services/store";
import { Item, RequiredRule } from "devextreme-react/form";
import uri from "../../utils/uri";
import http from "../../utils/http";
import notify from "devextreme/ui/notify";
import { dataAccess, resources } from "../../data/app";
import useAuthorization from "../../hooks/useAuthorization";

const Users = () => {

    const [ authorized ] = useAuthorization( resources.adminUsuario );

    const dataGrid = useRef();

    const reload = () => {
        dataGrid.current.instance.refresh();
    }

    const addMenuItems = (e) => {

        if (e.target == "content") {
            if (!e.items) e.items = [];

            let { username, active } = e.row.data;
 
            e.items.push({
                text: `${active ? 'Anular' : 'Activar'} usuario`,
                icon :  active ? 'remove' : 'check',
                onItemClick: () => {                    

                    http('users/update').asGet({username, active: !active}).then(resp => {
                        reload();
                        notify("Usuario actualizado correctamente");
                    });                    

                }
            },{
                text: `Restablecer contraseña`,
                icon :  'refresh',
                onItemClick: () => {
                    
                    let result = confirm("<i>Estas seguro de restablecer la contraseña?</i>", "Confirmar");
                    result.then((dialogResult) => {
                        if(dialogResult)
                            http('account/resetpassworddefault').asPost({username}).then(resp => {
                                notify("Contraseña retablecida correctamente");
                            });
                    });

                   
                }
            });
        }
    }

    const onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Nuevo usuario',
                icon: 'add',
                type: 'default',
                stylingMode: "outlined",
                onClick: () => dataGrid.current.instance.addRow()
            }
        },{
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon: 'exportxlsx',
                type: 'success',
                stylingMode: "outlined",
                onClick: () => dataGrid.current.instance.exportToExcel(false)
            }
        });
    }

    const setCellValue = (prop, newData, value, currentRowData) => {

        newData[prop] = value || '';
        if(prop == 'email' && value){

            let username = '';
            if(String(value).length > 0)
                username = String(value).split('@')[0];
            newData['username'] = username;
           
        }        
        
    }
   
    const title = "Usuarios";

    return authorized(
        <div className="container">
                <Title title={title} />
                <BlockHeader title={title} />
                <DataGrid
                    ref={dataGrid}
                    dataSource={store({ uri: uri.users, remoteOperations : true})}
                    selection={{ mode: 'single' }}
                    showBorders={true}
                    showRowLines={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    hoverStateEnabled={true}
                    onContextMenuPreparing={addMenuItems}
                    remoteOperations={{
                        paging: true,
                        filtering: true
                    }}
                    onToolbarPreparing={onToolbarPreparing}
                >
                    <Pager allowedPageSizes={[15, 30, 50]} showPageSizeSelector={true} showInfo={true} />
                    <Paging defaultPageSize={30} />
                    <SearchPanel visible={true} width={250} />
                    <FilterRow visible={true} />                 
                    <Export enabled={false} fileName={title} allowExportSelectedData={true} />
                    <Column dataField="username" width={140} allowEditing={false}/>
                    <Column dataField="code" caption={'Codigo'} width={140} />
                    <Column dataField="fullName" caption="Nombre" />
                    <Column dataField="email" allowFiltering={false} setCellValue={setCellValue.bind(null, 'email')}/>
                    <Column dataField="areaId" width={150} caption="Area">
                        <Lookup disabled={true} dataSource={createStore({name :'area'})} valueExpr="id" displayExpr="name" />
                    </Column>
                    <Column dataField="rolId" width={160} caption="Permisos">
                        <Lookup disabled={true} dataSource={createStore({name :'rol'})} valueExpr="id" displayExpr="name" />
                    </Column>
                    <Column dataField="active" caption="Activo" dataType="boolean"  width={100}/>
                    <Editing
                        mode="popup"
                        allowUpdating={true}    
                        useIcons={true}                        
                    >
                        <Popup title={title} showTitle={true} width={380} height={430}>                           
                        </Popup>
                        <Form colCount={1}>
                            <Item dataField="username">
                            </Item>
                            <Item dataField="code">
                                <RequiredRule message="El nombre es requerido" />
                                <StringLengthRule max={5} min={2} message="Máximo de caracteres 5 y 2 mínimo" />
                            </Item>
                            <Item dataField="fullName" >
                                <RequiredRule message="El nombre es requerido" />
                                <StringLengthRule max={150} min={5} message="Máximo de caracteres 150 y 5 mínimo" />
                            </Item>
                            <Item dataField="email" >
                                <RequiredRule message="El email es requerido" />
                                <EmailRule />
                                <StringLengthRule max={50} min={5} message="Máximo de caracteres 50 y 5 mínimo" />
                            </Item>                          
                            <Item dataField="areaId" >
                                <RequiredRule message="El area es requerida" />
                            </Item>
                            <Item dataField="rolId" >
                                <RequiredRule message="El rol es requerido" />
                            </Item>

                        </Form>
                    </Editing>
                </DataGrid>
            </div>
    );
}

export default Users;

